/**
 * @param props
 */

export default (props) => {
    return {
        loading: false,
        mounted() {

        },
        suggest() {
            if (this.service..guest) {
                this..visible = true;
                this..loaded = true;
                return false;
            }
            this.modules.display.playerSuggest = true;
        },
        report() {
            if (this.service..guest) {
                this..visible = true;
                this..loaded = true;
                return false;
            }
            this.modules.display.playerReport = true;
        },
        playlist() {
            if (this.service..guest) {
                this..visible = true;
                this..loaded = true;
                return false;
            }
            this.modules.display.playlists = true;
        },
        like() {
            if (this.loading) {
                return false;
            }
            this.loading = true;

            fetch(this.service.video.links.like)
                .then((r) => r.json())
                .then((r) => {
                    this.service.video.dislikes.disliked = false;
                    this.service.video.dislikes.counter = r.dislikes;
                    this.service.video.likes.counter = r.likes;
                    this.service.video.likes.liked = !this.service.video.likes.liked;
                    this.loading = false;
                });

        },
        dislike() {
            if (this.loading) {
                return false;
            }
            this.loading = true;
            fetch(this.service.video.links.dislike)
                .then((r) => r.json())
                .then((r) => {
                    this.service.video.likes.liked = false;
                    this.service.video.likes.counter = r.likes;
                    this.service.video.dislikes.counter = r.dislikes;
                    this.service.video.dislikes.disliked = !this.service.video.dislikes.disliked;
                    this.loading = false;
                });

        },
        () {
            if (!this.service.video..available) {
                this..visible = true;
                this..loaded = true;
            } else {
                // $modules.toggle('players');
            }
        },
        favorite() {
            if (this.service..guest === true) {
                this..visible = true;
                this..loaded = true;
                return false;
            }

            this.loading = true;

            fetch( this.service.video.favorite.added ? this.service.video.favorite.remove : this.service.video.favorite.add,{
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: "POST",
                    body: JSON.stringify({
                        [this.service.security.csrfToken.name]: this.service.security.csrfToken.value,
                        movie_id: this.service.video.id,
                    })
                })
                .then((data) => {
                    return data.json();
                })
                .then((data) => {
                    this.loading = false;
                    this.service.video.favorite.added = !this.service.video.favorite.added;
                })

        },



    }
};
